var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessOfferSmoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,26h20c2.2,0 4,1.8 4,4v2H12z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31,26h5v6h-5z",
    fill: "#E53935"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19,17c2.4,-2.2 2.5,-4.8 0.2,-7.7c4.1,1.8 5.4,5.1 3.6,8.4c-1,1.7 -0.5,2.9 1.6,3.9C21.3,22.1 19.5,20.2 19,17zM28,16.5c1.9,-1.7 2.1,-3.8 0.2,-6c3.2,1.5 4.1,4.1 2.7,6.6c-0.7,1.4 -0.3,2.3 1.2,3.2C29.7,20.6 28.4,19 28,16.5z",
    fill: "#00D4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessOfferSmoke);
export default __webpack_public_path__ + "static/media/p4r_business_offer_smoke.c306a532ec982697d10a53f2653501d8.svg";
export { ForwardRef as ReactComponent };